var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_20160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6933 8.05755C22.1879 6.8415 21.1627 5.5285 20.3599 5.11345C20.9324 6.22203 21.3298 7.41258 21.5379 8.64277L21.54 8.66228C20.2249 5.38505 17.9956 4.06155 16.174 1.18348C16.0818 1.03792 15.9897 0.892066 15.9 0.738108C15.8486 0.650175 15.8075 0.570946 15.7718 0.498018C15.6963 0.35173 15.6381 0.197127 15.5983 0.0373455C15.5984 0.0299724 15.5957 0.0228377 15.5909 0.0173025C15.586 0.0117673 15.5793 0.00821888 15.5719 0.00733428C15.5648 0.00536774 15.5572 0.00536774 15.55 0.00733428C15.5485 0.00733428 15.5461 0.0100353 15.5443 0.0106355C15.5425 0.0112357 15.5386 0.0139368 15.5359 0.0151372L15.5404 0.00733428C12.6188 1.71798 11.627 4.88416 11.5369 6.46876C10.3698 6.54878 9.25384 6.97873 8.33472 7.70252C8.23887 7.62133 8.13868 7.54539 8.03461 7.47503C7.76961 6.54736 7.75831 5.56559 8.0019 4.63207C6.92895 5.1518 5.97559 5.88862 5.20215 6.79588H5.19675C4.73577 6.21156 4.76819 4.28484 4.7946 3.88239C4.65822 3.93719 4.52805 4.00631 4.40625 4.08856C3.99931 4.379 3.61888 4.70489 3.26942 5.06243C2.8712 5.46617 2.50749 5.90256 2.18212 6.36702V6.36882V6.36672C1.4344 7.4266 0.903995 8.62408 0.62153 9.89004L0.605925 9.96687C0.584016 10.0692 0.505087 10.5818 0.491582 10.6931C0.491582 10.7018 0.489781 10.7099 0.488881 10.7186C0.387067 11.2479 0.323976 11.7838 0.30011 12.3222V12.3822C0.30525 15.2928 1.4014 18.0958 3.37217 20.2378C5.34294 22.3797 8.04512 23.705 10.9453 23.952C13.8454 24.199 16.7328 23.3498 19.0374 21.572C21.3421 19.7942 22.8965 17.217 23.3938 14.3491C23.4133 14.1991 23.4292 14.0505 23.4466 13.8989C23.6862 11.9188 23.4268 9.91012 22.6921 8.05575L22.6933 8.05755ZM9.28728 17.163C9.3416 17.1891 9.39262 17.2173 9.44844 17.2422L9.45654 17.2473C9.40012 17.2203 9.3437 17.1922 9.28728 17.163ZM21.5403 8.66558V8.65448L21.5424 8.66678L21.5403 8.66558Z",
    fill: "url(#paint0_linear_840_20160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6933 8.05739C22.1879 6.84133 21.1627 5.52834 20.3599 5.11328C20.9324 6.22187 21.3297 7.41241 21.5379 8.6426V8.65371L21.54 8.66601C22.4366 11.2317 22.307 14.0447 21.178 16.517C19.8449 19.3773 16.6193 22.3091 11.5684 22.1651C6.11237 22.0105 1.30457 17.9605 0.40723 12.6575C0.243668 11.8211 0.40723 11.397 0.48946 10.7173C0.377293 11.2453 0.314698 11.7826 0.30249 12.3223V12.3823C0.307631 15.293 1.40378 18.0959 3.37455 20.2379C5.34532 22.3799 8.0475 23.7051 10.9477 23.9522C13.8478 24.1992 16.7352 23.35 19.0398 21.5721C21.3444 19.7943 22.8988 17.2171 23.3962 14.3492C23.4157 14.1992 23.4316 14.0506 23.449 13.8991C23.6886 11.9189 23.4292 9.91025 22.6945 8.05588L22.6933 8.05739Z",
    fill: "url(#paint1_radial_840_20160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6933 8.05739C22.1879 6.84133 21.1627 5.52834 20.3599 5.11328C20.9324 6.22187 21.3297 7.41241 21.5379 8.6426V8.65371L21.54 8.66601C22.4366 11.2317 22.307 14.0447 21.178 16.517C19.8449 19.3773 16.6193 22.3091 11.5684 22.1651C6.11237 22.0105 1.30457 17.9605 0.40723 12.6575C0.243668 11.8211 0.40723 11.397 0.48946 10.7173C0.377293 11.2453 0.314698 11.7826 0.30249 12.3223V12.3823C0.307631 15.293 1.40378 18.0959 3.37455 20.2379C5.34532 22.3799 8.0475 23.7051 10.9477 23.9522C13.8478 24.1992 16.7352 23.35 19.0398 21.5721C21.3444 19.7943 22.8988 17.2171 23.3962 14.3492C23.4157 14.1992 23.4316 14.0506 23.449 13.8991C23.6886 11.9189 23.4292 9.91025 22.6945 8.05588L22.6933 8.05739Z",
    fill: "url(#paint2_radial_840_20160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0391 9.42339C17.0644 9.4411 17.0878 9.4588 17.1115 9.47651C16.8193 8.95842 16.4556 8.48409 16.0311 8.06748C12.4147 4.45113 15.0836 0.228543 15.5335 0.0124619L15.538 0.00585938C12.6164 1.7165 11.6245 4.88269 11.5345 6.46728C11.6701 6.45798 11.8046 6.44657 11.9432 6.44657C12.9798 6.44858 13.9973 6.72501 14.8924 7.24777C15.7874 7.77052 16.5281 8.52096 17.0391 9.42279V9.42339Z",
    fill: "url(#paint3_radial_840_20160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9493 10.146C11.9301 10.4353 10.9079 11.4332 10.5504 11.4332C7.24319 11.4332 6.70599 13.434 6.70599 13.434C6.85245 15.1189 8.02649 16.5072 9.44572 17.2395C9.51055 17.2731 9.57627 17.3034 9.64199 17.3331C9.75584 17.3835 9.86968 17.4301 9.98352 17.4729C10.4706 17.6453 10.9808 17.7437 11.497 17.765C17.2952 18.0369 18.4176 10.8324 14.2337 8.74057C15.2207 8.61216 16.2201 8.85483 17.0383 9.42153C16.5273 8.5197 15.7866 7.76926 14.8915 7.24651C13.9964 6.72375 12.9789 6.44732 11.9424 6.44531C11.8043 6.44531 11.6693 6.45672 11.5336 6.46602C10.3665 6.54604 9.25052 6.97599 8.3314 7.69978C8.50877 7.84984 8.70894 8.05031 9.1306 8.46597C9.9199 9.24356 11.9442 10.0491 11.9487 10.1436L11.9493 10.146Z",
    fill: "url(#paint4_radial_840_20160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9493 10.146C11.9301 10.4353 10.9079 11.4332 10.5504 11.4332C7.24319 11.4332 6.70599 13.434 6.70599 13.434C6.85245 15.1189 8.02649 16.5072 9.44572 17.2395C9.51055 17.2731 9.57627 17.3034 9.64199 17.3331C9.75584 17.3835 9.86968 17.4301 9.98352 17.4729C10.4706 17.6453 10.9808 17.7437 11.497 17.765C17.2952 18.0369 18.4176 10.8324 14.2337 8.74057C15.2207 8.61216 16.2201 8.85483 17.0383 9.42153C16.5273 8.5197 15.7866 7.76926 14.8915 7.24651C13.9964 6.72375 12.9789 6.44732 11.9424 6.44531C11.8043 6.44531 11.6693 6.45672 11.5336 6.46602C10.3665 6.54604 9.25052 6.97599 8.3314 7.69978C8.50877 7.84984 8.70894 8.05031 9.1306 8.46597C9.9199 9.24356 11.9442 10.0491 11.9487 10.1436L11.9493 10.146Z",
    fill: "url(#paint5_radial_840_20160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7897 7.31642C7.88393 7.37644 7.96166 7.42866 8.02979 7.47578C7.76479 6.54811 7.75349 5.56633 7.99708 4.63281C6.92413 5.15255 5.97077 5.88936 5.19733 6.79662C5.25405 6.79512 6.94128 6.76481 7.7897 7.31642Z",
    fill: "url(#paint6_radial_840_20160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.405146 12.6581C1.30278 17.9611 6.11028 22.0126 11.5663 22.1657C16.6172 22.3085 19.8434 19.3764 21.1759 16.5176C22.3049 14.0453 22.4345 11.2323 21.5379 8.66661V8.65551C21.5379 8.6468 21.5361 8.6417 21.5379 8.6444L21.54 8.66391C21.9526 11.358 20.5823 13.9669 18.4398 15.7346L18.4332 15.7496C14.2586 19.1498 10.2641 17.8005 9.45684 17.2501C9.40042 17.2231 9.344 17.195 9.28758 17.1658C6.85396 16.0026 5.84829 13.7865 6.06437 11.8838C5.48668 11.8923 4.91892 11.7332 4.42988 11.4255C3.94083 11.1179 3.55149 10.6751 3.30903 10.1507C3.94791 9.75931 4.67637 9.53806 5.42498 9.50801C6.1736 9.47796 6.91745 9.64011 7.58564 9.979C8.96294 10.6042 10.5301 10.6658 11.9523 10.1507C11.9478 10.0561 9.92351 9.25033 9.13422 8.47304C8.71256 8.05738 8.51239 7.85721 8.33502 7.70685C8.23916 7.62566 8.13898 7.54972 8.03491 7.47937C7.96588 7.43225 7.88815 7.38123 7.79482 7.32001C6.9464 6.7684 5.25917 6.79871 5.20334 6.80021H5.19794C4.73697 6.21589 4.76938 4.28917 4.79579 3.88672C4.65942 3.94153 4.52924 4.01064 4.40745 4.0929C4.0005 4.38333 3.62007 4.70922 3.27062 5.06676C2.87097 5.46937 2.50576 5.90475 2.17881 6.36835V6.37015V6.36805C1.43109 7.42793 0.900691 8.62541 0.618226 9.89137C0.612524 9.91508 0.199269 11.7218 0.403045 12.6587L0.405146 12.6581Z",
    fill: "url(#paint7_radial_840_20160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0308 8.0664C16.4554 8.48346 16.8191 8.95831 17.1112 9.47693C17.1751 9.52525 17.2348 9.57326 17.2856 9.61978C19.9226 12.0507 18.5409 15.487 18.438 15.7301C20.5802 13.9651 21.9493 11.3544 21.5382 8.65942C20.2225 5.37919 17.9908 4.0557 16.1721 1.17762C16.08 1.03206 15.9879 0.886207 15.8981 0.732249C15.8468 0.644316 15.8057 0.565086 15.77 0.492159C15.6944 0.34587 15.6362 0.191267 15.5965 0.0314862C15.5966 0.024113 15.5939 0.0169784 15.589 0.0114431C15.5842 0.00590788 15.5774 0.00235951 15.5701 0.0014749C15.5629 -0.000491634 15.5554 -0.000491634 15.5482 0.0014749C15.5467 0.0014749 15.5443 0.00417592 15.5425 0.00477614C15.5407 0.00537637 15.5368 0.00807738 15.5341 0.00927783C15.0842 0.222658 12.4159 4.44794 16.0323 8.0613L16.0308 8.0664Z",
    fill: "url(#paint8_radial_840_20160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2853 9.62144C17.2346 9.57493 17.1748 9.52691 17.1109 9.47859C17.0872 9.46088 17.0638 9.44318 17.0386 9.42547C16.2204 8.85877 15.221 8.6161 14.234 8.74451C18.4176 10.8363 17.2952 18.039 11.4973 17.7689C10.9811 17.7477 10.4709 17.6492 9.98385 17.4769C9.87 17.4343 9.75616 17.3877 9.64232 17.337C9.57659 17.307 9.51087 17.277 9.44604 17.2434L9.45415 17.2485C10.2627 17.8004 14.2559 19.1488 18.4305 15.7479L18.4371 15.7329C18.5413 15.4898 19.923 12.0536 17.2847 9.62264L17.2853 9.62144Z",
    fill: "url(#paint9_radial_840_20160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70631 13.4323C6.70631 13.4323 7.24321 11.4314 10.5508 11.4314C10.9082 11.4314 11.9313 10.4335 11.9496 10.1442C10.5274 10.6594 8.96024 10.5977 7.58294 9.97257C6.91475 9.63368 6.1709 9.47153 5.42229 9.50158C4.67367 9.53163 3.94521 9.75287 3.30634 10.1442C3.5488 10.6686 3.93813 11.1115 4.42718 11.4191C4.91622 11.7267 5.48398 11.8859 6.06167 11.8774C5.84619 13.7792 6.85156 15.9949 9.28488 17.1594C9.3392 17.1855 9.39022 17.2137 9.44604 17.2386C8.02561 16.5048 6.85277 15.1171 6.70631 13.4332V13.4323Z",
    fill: "url(#paint10_radial_840_20160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6933 8.05755C22.1879 6.8415 21.1627 5.5285 20.3599 5.11345C20.9324 6.22203 21.3298 7.41258 21.5379 8.64277L21.54 8.66228C20.2249 5.38505 17.9957 4.06155 16.174 1.18348C16.0818 1.03792 15.9897 0.892066 15.9 0.738108C15.8487 0.650175 15.8075 0.570946 15.7718 0.498018C15.6963 0.35173 15.6381 0.197127 15.5984 0.0373455C15.5984 0.0299724 15.5957 0.0228377 15.5909 0.0173025C15.586 0.0117673 15.5793 0.00821888 15.5719 0.00733428C15.5648 0.00536774 15.5572 0.00536774 15.55 0.00733428C15.5485 0.00733428 15.5461 0.0100353 15.5443 0.0106355C15.5425 0.0112357 15.5386 0.0139368 15.5359 0.0151372L15.5404 0.00733428C12.6188 1.71798 11.627 4.88416 11.5369 6.46876C11.6726 6.45945 11.807 6.44805 11.9457 6.44805C12.9822 6.45005 13.9998 6.72649 14.8948 7.24924C15.7899 7.772 16.5306 8.52244 17.0416 9.42426C16.2234 8.85756 15.224 8.61489 14.237 8.74331C18.4206 10.8351 17.2982 18.0378 11.5003 17.7677C10.9841 17.7465 10.4739 17.648 9.98685 17.4757C9.87301 17.4331 9.75917 17.3864 9.64532 17.3358C9.5796 17.3058 9.51388 17.2758 9.44905 17.2422L9.45715 17.2473C9.40073 17.2203 9.34431 17.1922 9.28789 17.163C9.34221 17.1891 9.39323 17.2173 9.44905 17.2422C8.02862 16.5081 6.85578 15.1204 6.70932 13.4368C6.70932 13.4368 7.24622 11.4359 10.5538 11.4359C10.9112 11.4359 11.9343 10.438 11.9526 10.1487C11.9481 10.0542 9.92383 9.2484 9.13453 8.47111C8.71287 8.05545 8.5127 7.85528 8.33533 7.70492C8.23948 7.62373 8.13929 7.54779 8.03522 7.47743C7.77022 6.54977 7.75892 5.56799 8.00251 4.63447C6.92956 5.1542 5.9762 5.89102 5.20276 6.79828H5.19736C4.73638 6.21396 4.7688 4.28724 4.79521 3.88479C4.65883 3.93959 4.52866 4.00871 4.40686 4.09097C3.99992 4.3814 3.61949 4.70729 3.27003 5.06483C2.87181 5.46857 2.5081 5.90496 2.18273 6.36942V6.37122V6.36912C1.43501 7.429 0.904606 8.62648 0.622141 9.89244L0.606535 9.96927C0.584627 10.0716 0.48649 10.5914 0.472385 10.703C0.382621 11.2396 0.325296 11.7811 0.30072 12.3246V12.3846C0.305861 15.2952 1.40201 18.0982 3.37278 20.2402C5.34355 22.3821 8.04573 23.7074 10.9459 23.9544C13.846 24.2014 16.7334 23.3522 19.0381 21.5744C21.3427 19.7966 22.8971 17.2194 23.3944 14.3515C23.4139 14.2015 23.4298 14.0529 23.4472 13.9013C23.6868 11.9212 23.4274 9.91252 22.6927 8.05815L22.6933 8.05755ZM21.5394 8.65508L21.5415 8.66738L21.5394 8.65508Z",
    fill: "url(#paint11_linear_840_20160)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_840_20160",
    x1: 21.1537,
    y1: 3.7227,
    x2: 1.84359,
    y2: 22.3537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_840_20160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4064 2.70638) scale(24.2491)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_840_20160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4031 12.6101) scale(24.2491)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_840_20160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4042 -2.69515) scale(17.5656 17.5656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_840_20160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.70204 18.9123) scale(11.5453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_840_20160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5759 10.5283) rotate(-13.5916) scale(6.12232 7.16771)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_840_20160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1029 1.80635) scale(8.30711 8.30712)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_840_20160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7054 -3.59599) scale(35.4433 35.4433)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_840_20160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7595 -1.63084) rotate(83.976) scale(25.9734 17.0461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_840_20160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.103 4.80764) scale(22.1243 22.1243)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_840_20160",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8051 6.00749) scale(24.2161)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_840_20160",
    x1: 20.9197,
    y1: 3.62366,
    x2: 4.49149,
    y2: 20.0548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_20160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/Firefox.2d18ab7a0286c9e3d10b4ebb59dcff4d.svg";
export { ForwardRef as ReactComponent };